/* =============================================================================
=    Query OrderDetails
============================================================================= */
import gql from 'graphql-tag';

export default gql`
  query orderDetails($confNum: String!) {
    orderDetails(confNum: $confNum) {
      _id
      orderNum
      orderStatus {
        id
        name
      }
      vehicleModel {
        id
        fullModelCode
        brand
        year
        region
        name
        model
        edition
        assetPath
        active
        vehicleMarketStatusDesc
        basePrice
        depositAmount
        preorderDepositAmount
        reserveSpotCap
        isWaitlistAllowed
      }
      orderPaymentCores {
        id
        paymentMethod
        billingFirstName
        billingLastName
        billingAddress1
        billingAddress2
        billingCity
        billingStateOrProvince
        billingZipcode
        billingCountry
        orderPaymentItems {
          id
          paidAmount
          currency
          createdAt
        }
        createdAt
      }
      vehicleConfigurationCore {
        configurationNum
        vehicleConfigurationItems {
          id
          quantity
          vehicleOption {
            id
            price
            vehicleOptionType {
              id
              categoryCode
              categoryName
              typeCode
              typeName
            }
          }
        }
      }
      createdAt
      isOnWaitlist
      waitlistJoinedAt
      canUpgradeEdition
      canDowngradeEdition
    }
  }
`;
